import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';

const API = process.env.REACT_APP_BACKEND_URL;

const BlogIndex = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/api/seo/public/articles`)
      .then(r => r.json())
      .then(data => setArticles(Array.isArray(data) ? data : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#09090b]">
      <Helmet>
        <title>Blog - Cloneia | Gestion des connaissances en entreprise</title>
        <meta name="description" content="Retrouvez nos articles sur la gestion des connaissances, la productivite en entreprise et le clone memoire des collaborateurs." />
        <link rel="canonical" href="https://cloneia.fr/blog" />
      </Helmet>

      <Header />

      <main className="max-w-5xl mx-auto px-6 pt-32 pb-20" data-testid="blog-index">
        <h1 className="text-4xl sm:text-5xl font-bold text-[#f5f5f5] mb-4">Blog</h1>
        <p className="text-[#71717a] text-lg mb-12 max-w-2xl">
          Reflexions et analyses sur la gestion des connaissances en entreprise, la memoire collective et la productivite des equipes.
        </p>

        {loading ? (
          <div className="flex justify-center py-20">
            <div className="w-6 h-6 border-2 border-[#3b82f6] border-t-transparent rounded-full animate-spin" />
          </div>
        ) : articles.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-[#52525b] text-lg">Aucun article pour le moment.</p>
            <p className="text-[#3f3f46] text-sm mt-2">Revenez bientot.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {articles.map(article => (
              <Link
                key={article.id || article.slug}
                to={`/blog/${article.slug}`}
                className="group rounded-2xl border border-white/5 bg-[#0f0f17] overflow-hidden hover:border-white/10 transition-all duration-300"
                data-testid={`blog-card-${article.slug}`}
              >
                {article.hero_image ? (
                  <div className="aspect-video overflow-hidden">
                    <img
                      src={article.hero_image}
                      alt={article.hero_image_alt || article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                ) : (
                  <div className="aspect-video bg-gradient-to-br from-[#1a1a2e] to-[#0f0f17]" />
                )}
                <div className="p-5">
                  {article.keyword && (
                    <span className="text-[#3b82f6] text-xs font-medium uppercase tracking-wider">{article.keyword}</span>
                  )}
                  <h2 className="text-[#f5f5f5] text-lg font-semibold mt-1.5 mb-2 group-hover:text-[#3b82f6] transition-colors line-clamp-2">
                    {article.title}
                  </h2>
                  {article.meta_description && (
                    <p className="text-[#71717a] text-sm line-clamp-2">{article.meta_description}</p>
                  )}
                  <div className="flex items-center gap-3 mt-4 text-[#52525b] text-xs">
                    {article.published_at && (
                      <span>{new Date(article.published_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
                    )}
                    {article.word_count > 0 && <span>{Math.ceil(article.word_count / 200)} min de lecture</span>}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
};

export default BlogIndex;
